var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63363 11.0583C9.55029 11.05 9.45029 11.05 9.35863 11.0583C7.37529 10.9916 5.80029 9.36663 5.80029 7.36663C5.80029 5.32496 7.45029 3.66663 9.50029 3.66663C11.542 3.66663 13.2003 5.32496 13.2003 7.36663C13.192 9.36663 11.617 10.9916 9.63363 11.0583Z",
    stroke: "#0F1653",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6752 5.33337C17.2919 5.33337 18.5919 6.64171 18.5919 8.25004C18.5919 9.82504 17.3419 11.1084 15.7836 11.1667C15.7169 11.1584 15.6419 11.1584 15.5669 11.1667",
    stroke: "#0F1653",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4666 14.1334C3.44993 15.4834 3.44993 17.6834 5.4666 19.025C7.75827 20.5584 11.5166 20.5584 13.8083 19.025C15.8249 17.675 15.8249 15.475 13.8083 14.1334C11.5249 12.6084 7.7666 12.6084 5.4666 14.1334Z",
    stroke: "#0F1653",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2832 18.6666C17.8832 18.5416 18.4499 18.3 18.9165 17.9416C20.2165 16.9666 20.2165 15.3583 18.9165 14.3833C18.4582 14.0333 17.8999 13.8 17.3082 13.6666",
    stroke: "#0F1653",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.906133c06c07431ebba3c42cb133bcbb.svg";
export { ForwardRef as ReactComponent };